export default __webpack_public_path__ + "static/media/WillWhalen.b9a3f2be.jpg";